package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class AppStaffResponse(
    val id: String? = null,
    @SerialName("user_id") val userId: String? = null,
    @SerialName("employee_id") val employeeId: String? = null,
    val name: String? = null,
    val gender: String? = null,
    val email: String? = null,
    val mobile: String? = null,
    @SerialName("profile_image_url") val profileImageUrl: String? = null,
    @SerialName("custom_attributes") val customAttributes: Map<String, JsonElement>? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    @SerialName("push_notification_enabled") val pushNotificationEnabled: Boolean? = null,
    @SerialName("email_notification_enabled") val emailNotificationEnabled: Boolean? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("created_by_id") val createdById: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("updated_by_id") val updatedById: String? = null
)
